module.exports = __webpack_public_path__ + "static/img/皮带大块煤识别.5092f6dc.png";